import React, {useContext} from "react";

// UI
import MaterialTable from "@material-table/core";
import _ from "lodash";

// Table Params
import { OPTIONS, LOCALIZATION, getColumns } from "./Params/References";
import { tableIcons } from "../../ui-components/TableIcons";
import TableStyle from "../TableStyle";
import UserNotificationsContext from "../../UserNotificationsContext";
import AuthenticationService from "../../services/AuthenticationService";
import {PRIVILEGED_ROLES} from "../../constants";


function ReferencesTable({ references, setReferences, countryCode, intl, countryApiRequest, push }) {

  const userData = AuthenticationService.getUserData();
  const showLinks = [...PRIVILEGED_ROLES, 'field'].includes(userData['role_type']);

  // context
  const { setUserNotifications } = useContext(UserNotificationsContext);

  // utilities
  const lkpStatus = references.reduce(
    (obj, {status}) => _.set(obj, [status], intl.formatMessage({id: status})),
    {}
  );

  const onAction = (rid, wid) => {
    // mark notification row as read
    setReferences((prev) => prev.map((r) =>
      (!rid && wid === r.cod_worksite_id) || (!!rid && r.id === rid)
        ? {...r, isNew: false, hasNotification: false, notificationTimestamp: new Date('0001-01-01T00:00:00Z')}
        : r
    ))
    // remove notification from navbar
    setUserNotifications((prev) => prev.filter((n) => rid
      ? n.cod_reference !== rid
      : n.val_type !== 'worksite_reference_report' || n.cod_worksite !== wid
    ))
  }

  return (
    <>
      <TableStyle>
        <MaterialTable
          columns={getColumns(intl, countryCode, lkpStatus, countryApiRequest, push, onAction, showLinks)}
          data={
            _.orderBy(
              references.map(i => ({...i, city_prov: `${i.city} (${i.cod_province})`, detail: i.content?.title})),
              ['notificationTimestamp', 'created_at'],
              ['desc', 'desc']
            )
          }
          icons={tableIcons}
          isLoading={!references}
          options={OPTIONS}
          localization={LOCALIZATION}
          pagination
        />
      </TableStyle>
    </>
  );
}

export default React.memo(ReferencesTable, (props, nextProps) => {
  // Render component only when users changes
  return _.isEqual(props.references, nextProps.references);
});
